(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/transitions"), require("popmotion"), require("stylefire"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/transitions", "popmotion", "stylefire"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/transitions"), require("popmotion"), require("stylefire")) : factory(root["../../utils/transitions"], root["popmotion"], root["stylefire"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__387__, __WEBPACK_EXTERNAL_MODULE__922__, __WEBPACK_EXTERNAL_MODULE__543__) {
return 